import React from 'react';
import Slider from 'react-slick';
import styles from './carousel.module.css';
import Card from './CarouselCard';
import "../../..//node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";


const NextArrow = (props) => {
  return (<i className={styles.left}>aaa</i>);
}

const SamplePrevArrow = (props) => {
  const {className, style, onClick} = props
  const styles = {
    height: '100%',
    width: '2%',
    backgroundColor: '#e6e6e6',
    paddingTop: '2.5%',
    left: "-2%"
  }
  return (
    <div
      className={className}
      style={styles}
      onClick={onClick}
    ></div>
  );
}

const SampleNextArrow = (props) => {
  const {className, style, onClick} = props
  const styles = {
    height: '100%',
    width: '2%',
    backgroundColor: '#e6e6e6',
    paddingTop: '2.5%',
    right: "-2%"
  }
  return (
    <div
      className={className}
      style={styles}
      onClick={onClick}></div>
  );
}

const desc = () => {
  return <div>aaaaaaaaaabbbaaa</div>;
}


const Carousel = ({universities, courses}) => {
  const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: false,
      autoplaySpeed: 2000,
      variableWidth:true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [{
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          variableWidth:true,
          nextArrow: <div />,
          prevArrow: <div />
        }
      }]
    };
    return (
      <div className={styles.main}>
        <Slider {...settings}>
          {Array.from(Array(10).keys()).map((x) => (<Card key={x} />))}
        </Slider>
      </div>
    );
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js